<template>
    <div class="col-lg-5 col-md-7">
        <div class="">
            <div class=" px-lg-5 pt-lg-5 pb-lg-2">
                <div class="login-header text-center mb-4">{{ $t('register') }}</div>
                <base-alert type="danger" v-if="error">{{error}}</base-alert>
                <base-alert type="primary mt-5 mb-8" v-if="registeredUser">{{ $t('at_email_') }}
                    {{registeredUser.email}} {{ $t('_send_email_with_instruction') }}
                </base-alert>
                <form role="form" v-if="!registeredUser">

                    <base-input class="input-group-alternative mb-3"
                                ref="name"
                                :placeholder="$t('email_address')"
                                :error="fieldError('email')"
                                addon-left-icon="ni ni-email-83"
                                v-model="email">
                    </base-input>

                    <base-input class="input-group-alternative mb-3"
                                ref="name"
                                :placeholder="$t('your_name')"
                                :error="fieldError('name')"
                                :disabled="registeredUser"
                                addon-left-icon="ni ni-hat-3"
                                @keyup.enter.prevent="submit"
                                v-model="username">
                    </base-input>

                    <div class="row mt-4 mb-3">
                        <div class="col-12">
                            <base-checkbox class="custom-control-alternative danger"
                                           v-model="agree"
                                           :disabled="registeredUser">
                                    <span class="user-policy">{{ $t('i_have_read_and_agree_to_the_terms_') }} <a
                                            href="/polzovatelskoe-soglashenie.html"
                                            target="_blank">{{ $t('_user_agreement_and_privacy_policy') }}</a></span>
                            </base-checkbox>
                            <base-checkbox class="mt-3 custom-control-alternative danger"
                                           v-model="agree2"
                                           :disabled="registeredUser">
                                <span class="user-policy">{{ $t('personal_data_agreement') }} *</span>
                            </base-checkbox>
                        </div>
                    </div>
                    <div class="text-center">
                        <base-button
                                data-model="user"
                                data-action="register"
                                :data-label="$t('do_register')"
                                :disabled="!submitEnabled" class="my-4 px-5 py-3 login-btn" @click="submit">
                            {{ $t('do_register') }}
                        </base-button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import userApi from "../../data/UserApi";
    import {getUser} from "../../data/jwt.service";


    export default {
        name: 'EmailRegister',
        props: {
            defaultLogin: String,
            defaultName: String,
        },
        data() {
            return {
                username: '',
                email: '',
                agree: true,
                agree2: true,

                error: null,
                fieldsErrors: [],
                loading: false,

                registeredUser: null,
            }
        },

        computed: {
            submitEnabled() {
                return this.agree && this.agree2
                    && this.username && this.username.length > 0
                    && this.email && this.email.length > 0
                    && !this.registeredUser
            },
        },

        mounted() {
            if (getUser()) {
                this.$router.push('/user/profile')
            }

            if (this.defaultLogin) {
                this.email = this.defaultLogin
                this.$refs.name.$el.querySelector('input').focus()
            } else {
                this.$refs.login.$el.querySelector('input').focus()
            }

            if (this.defaultName) {
                this.username = this.defaultName
            }
        },

        methods: {
            submit() {
                if (!this.submitEnabled) return
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                let returnUrl = null
                if ('return' in this.$route.query) returnUrl = this.$route.query.return
                userApi.shortRegistration(this.username, this.email, returnUrl)
                    .then(response => {
                        this.registeredUser = response
                        this.loading = false
                        this.$router.push('/user/login?short')
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>

<style scoped>

</style>
